import { useNavigate } from "react-router-dom";
import { ROUTES } from "./routePaths";
import { Navigate } from "react-router-dom";
import useAppStore from "../store/useAppStore";

const PublicRoutes = ({ children }) => {
  const userToken = useAppStore((state) => state.userToken);
  const navigate = useNavigate();

  if (userToken) return <Navigate to={ROUTES.APP_INITIALIZER} replace />;

  return children;
};

export default PublicRoutes;
